/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useSelector } from 'react-redux';
import Project from 'src/entities/project';
import { getProject } from 'src/selectors/projects';

const useCurrentUserProjectRole = ( projectID?: number | null ) => {
	// @ts-ignore
	const project: Project | undefined = useSelector( state => getProject( state, { projectID } ) );

	return project?.currentUserRole;
};

export default useCurrentUserProjectRole;
